(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerLead',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		Adzuki.LivePlannerParticipants.init(form.name);

		$('#liveplannerlead-agent_id').change(function loadAgentSchedule() {
			var $self      = $(this),
				agent_id   = $self.val(),
				appoinment = $('#liveplannerlead-appointment'),
				iteration  = 0,
				optgroup;

			Adzuki.Ajax.get('/LivePlanner/getAppointmentsForAgentId/' + agent_id)
			.then(function setSchedule(response)
			{
				if (response.disable === 'true') {
					$('.appointment-group').addClass('hidden');
					appoinment.empty();
					appoinment.append($('<option>').text('Please Select').attr('value', 'request'));
				} else {
					$('.appointment-group').removeClass('hidden');
					appoinment.empty();
					appoinment.append($('<option>').text('Please Select').attr('value', 0));

					$.each(response, function parseSlots(key, slots) {
						optgroup = $('<optgroup>');

						if (key !== '0') {
							optgroup.attr('label', key);

							$.each(slots, function parseSlot(sKey, sValue) {
								optgroup.append($('<option>').text(sValue).attr('value', sKey));
							});

							appoinment.append(optgroup);
							iteration++;
						}
					});

					if (iteration === 0) {
						Adzuki.StatusMessage('Error', 'The advisor selected does not have any upcoming appointment times available. Please select a different advisor or reach out to your advisor directly.');
					}
				}
			});
		});

		$('#liveplannerlead-appointment').change(function loadAgentSchedule() {
			var $self      = $(this),
				appoinment = $self.val(),
				date       = '',
				formatted  = '<em>none</em>';

				if (appoinment !== '') {
					date      = new Date(appoinment * 1000);
					formatted = moment(date).format('llll');
				}

				$('.lp-selected-appointment').html(formatted);
		});

		Adzuki.CharacterCount('#liveplannerlead-comments', {
			max  : 255,
			label: '#lp-comment-count',
		});
	};

}(jQuery, window.Adzuki || {}));
